import React, { Component } from "react";
import { geolocated } from "react-geolocated";

import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core";

// Icons
import LockIcon from "@material-ui/icons/Lock";

import Webcam from "react-webcam";

import { connect } from "react-redux";
import PublicIp from "react-public-ip";
import ModalAlert from "../../components/ModalAlert";
import { detectar_mobile } from "../../utils";
import {
  salvarArquivo,
  limpaMsg,
  enviarEmailSig,
  deslogar,
} from "../../actions";

class SelfieScreen extends Component {
  constructor(props) {
    super(props);

    let user = JSON.parse(localStorage.getItem("user"));

    this.state = {
      width: 0,
      height: 0,
      modalToken: false,
      load: false,
      form: {
        token: user ? user.token : null,
        cpfCnpj: user ? user.cpfCnpj : null,
        categoria: "selfie",
        base64file: "",
      },
      email: user ? user.email : null,
      confirm: false,
      semSelfie: false,
      selfieBase64file: "",
      cameraDesabilitada: false,
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.inputChange = this.inputChange.bind(this);
  }

  async componentDidMount() {
    // if(!localStorage.getItem('user'))
    //     this.props.history.push('/')
    const exigencia = await localStorage.getItem("exigencia");
    if (exigencia) {
      this.setState({ exigencia: JSON.parse(exigencia), selfieBase64file: "" });
    }

    await this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  async updateWindowDimensions() {
    var width =
      window.innerWidth > 1280
        ? window.innerWidth * 0.6
        : window.innerWidth < 500
        ? window.innerWidth * 0.95
        : window.innerWidth * 0.8;
    await this.setState({ width, height: window.innerHeight * 0.9 });
  }

  async saveData() {
    this.setState({ load: true, confirm: false });
    this.props.limpaMsg();
    const { form, selfieBase64file } = this.state;

    form["base64file"] = await selfieBase64file.replace(
      "data:image/png;base64,",
      ""
    );

    this.setState({ form });
    this.salvarArquivo(form);
  }

  clear() {
    this.props.limpaMsg();

    // LIMPAR SELFIE PARA TIRAR OUTRA
    this.setState({ selfieBase64file: "" });
  }

  inputChange(e) {
    const { form } = this.state;
    form[e.target.name] = e.target.value;
    this.setState({ form });
  }

  async dataURLtoFile(dataurl, filename) {
    var arr = await dataurl.split(","),
      mime = await arr[0].match(/:(.*?);/)[1],
      bstr = await atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = await bstr.charCodeAt(n);
    }

    return await new File([u8arr], filename, { type: mime });
  }

  async salvarArquivo(form) {
    //form.preventDefault()

    var { form } = this.state;
    var assinatura = {};

    const ip = await PublicIp.v4();

    form.ip = ip;

    if (this.props.isGeolocationEnabled) {
      form.latitude = this.props.coords.latitude;
      form.longitude = this.props.coords.longitude;
    }

    for (let i in form) {
      if (form[i] == "") return alert("Preencha todos os campos!");
      if (i != "arquivo") assinatura[i] = form[i];
    }

    this.props.salvarArquivo(form, (err) => {
      this.setState({ load: false });

      if (!err) {
        localStorage.clear();
        this.props.history.push("/conclusao");
      }
    });
  }

  async verificarSelfie() {
    let imagemSelfie = this.webselfie.getScreenshot() || "";

    if (imagemSelfie.length > 0) {
      this.setState({
        selfieBase64file: imagemSelfie,
        cameraDesabilitada: false,
      });
    } else {
      this.setState({ cameraDesabilitada: true });
    }
  }

  render() {
    const { arquivo_load, arquivo_msg, arquivo_error, contatar_load } =
      this.props.documentos;
    const { selfieBase64file, cameraDesabilitada } = this.state;
    const alert = arquivo_error ? "danger" : "success";

    const videoConstraints = {
      facingMode: "user",
    };

    return (
      <Container
        style={{
          alignItems: "center",
          width: "100%",
          /*height:'100%',*/ display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {!this.state.load && this.state.selfieBase64file.length === 0 ? (
          <div
            style={{
              alignItems: "center",
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                marginTop: "2rem",
                top: "15%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <h2>
                <b>Selfie</b>
              </h2>
              <p style={{ width: "80%" }}>
                Para confirmar sua assinatura via web, por favor, registre sua
                selfie.
              </p>
            </div>

            <div
              style={{
                position: "relative",
                width:
                  this.state.width <= 820
                    ? this.state.width * 0.92
                    : this.state.width * 0.75,
                height:
                  this.state.width * 0.7 > 180 ? this.state.height * 0.5 : 180,
                margin: "0 auto",
                marginTop: "3%",
                marginBottom: "3%",
              }}
            >
              <Webcam
                ref={(ref) => (this.webselfie = ref)}
                screenshotFormat="image/png"
                audio={false}
                width={
                  this.state.width <= 820
                    ? this.state.width * 0.92
                    : this.state.width * 0.75
                }
                height={
                  this.state.width * 0.7 > 180 ? this.state.height * 0.5 : 180
                }
                minScreenshotWidth={this.state.width * 0.75}
                minScreenshotHeight={
                  this.state.width * 0.7 > 180 ? this.state.height * 0.5 : 180
                }
                videoConstraints={videoConstraints}
                screenshotQuality={1}
                style={{
                  //   marginTop: "3%",
                  //   marginBottom: "3%",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
              <img
                src="/assets/imagem/faceFrame.svg"
                alt="Imagem Guia"
                style={{
                  //   marginTop: "3%",
                  //   marginBottom: "3%",
                  position: "absolute",
                  height:
                    this.state.width * 0.26 > 180
                      ? this.state.width * 0.26
                      : 180,
                  zIndex: 1,
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            </div>

            <div
              style={{
                /*position: 'absolute', /*left: '6%',*/ bottom: "5px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {(arquivo_error || arquivo_error === "Erro:") &&
              !cameraDesabilitada ? (
                <span
                  style={{
                    color: "red",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Erro: {arquivo_msg}
                </span>
              ) : null}
              {cameraDesabilitada ? (
                <span
                  style={{
                    color: "red",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Erro: Sua câmera está desabilidade ou você não forneceu
                  permissão de acesso a ela.
                </span>
              ) : null}
              {this.state.load && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress />
                </div>
              )}

              {!this.state.load &&
                this.state.selfieBase64file.length === 0 &&
                !cameraDesabilitada && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      style={{
                        minHeight: 50,
                        minWidth: 120,
                        fontSize: "x-large",
                        width: "20%",
                      }}
                      className="bg-primary text-light ml-2 mt-2"
                      variant="contained"
                      onClick={() => this.verificarSelfie()}
                    >
                      Tirar Selfie
                    </Button>
                  </div>
                )}
            </div>
            <div></div>
          </div>
        ) : (
          <div
            className="canvas-container"
            style={{
              alignItems: "center",
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                marginTop: "2rem",
                top: "15%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <h2>Verificar Selfie</h2>
              {
                /*!detectar_mobile() &&*/
                <span>Verifique se sua selfie está boa.</span>
              }
              <p>Lembramos que sua selfie será validada.</p>
            </div>

            {this.state.selfieBase64file.length > 0 && (
              <div id="image-selfie">
                <img
                  style={{
                    height:
                      this.state.width * 0.7 > 180
                        ? this.state.width * 0.5
                        : 200,
                    marginTop: "3%",
                    marginBottom: "3%",
                  }}
                  src={selfieBase64file}
                  alt="sign"
                />
              </div>
            )}

            <div
              style={{
                /*position: 'absolute', /*left: '6%',*/ bottom: "5px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {this.state.load && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress />
                </div>
              )}
              {arquivo_error || arquivo_error === "Erro:" ? (
                <span
                  style={{
                    color: "red",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Erro: {arquivo_msg}
                </span>
              ) : null}
              {!this.state.load && this.state.selfieBase64file.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    style={{ maxHeight: 36 }}
                    className="bg-danger text-light mt-2"
                    variant="contained"
                    onClick={() => this.clear()}
                  >
                    Não gostei
                  </Button>
                  <Button
                    style={{
                      minHeight: 50,
                      minWidth: 120,
                      fontSize: "x-large",
                      width: "20%",
                    }}
                    className="bg-primary text-light ml-2 mt-2"
                    variant="contained"
                    onClick={() => this.saveData()}
                  >
                    Ficou bom
                  </Button>
                </div>
              )}
            </div>
            <div></div>
          </div>
        )}

        {/* MODAL TOKEN */}
        <Dialog
          open={this.state.modalToken}
          //TransitionComponent={Transition}
          keepMounted
          onClose={() => this.setState({ modalToken: false })}
          fullWidth
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            <h5 className="modal-title" id="modalSendDoc">
              Assinar documento <LockIcon />
            </h5>
          </DialogTitle>
          <form
            style={{ textAlign: "left" }}
            onSubmit={(event) => this.salvarArquivo(event)}
          >
            <DialogContent>
              <div style={{ textAlign: "center" }}>
                <img
                  id="assinatura-confirm"
                  style={{ height: "100%", maxHeight: "150px" }}
                />
              </div>
              <div className="form-group">
                Enviamos para o seu e-mail um <b>código</b> para autenticar sua
                assinatura. Por favor insira o código.
              </div>
              <div className="form-group">
                <input
                  placeholder="Informe o código"
                  type="text"
                  className="form-control"
                  name="token"
                  onChange={this.inputChange}
                  value={this.state.form.token}
                  required
                />

                {
                  contatar_load ? (
                    <div
                      style={{
                        float: "right",
                        marginRight: "5%",
                        marginTop: "1%",
                      }}
                      className="spinner-border text-primary"
                      role="status"
                    ></div>
                  ) : null
                  /* <div className="form-group">
                                        <span style={{float:'right',marginTop:'1%',cursor:'pointer'}} 
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={ () => this.props.enviarEmailSig(documento_id,signatario_id)}>Reenviar token</span>
                                    </div> */
                }
              </div>
              {arquivo_msg != "" ? (
                <div className={`alert alert-${alert}`} role="alert">
                  {arquivo_msg}
                </div>
              ) : null}
            </DialogContent>
            <DialogActions>
              <div className="form-group">
                {arquivo_load ? (
                  <CircularProgress />
                ) : (
                  <div>
                    <Button
                      onClick={() => this.setState({ modalToken: false })}
                      disabled={contatar_load}
                    >
                      Cancelar
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      style={{ backgroundColor: "#28a745", color: "white" }}
                      disabled={contatar_load}
                    >
                      Enviar
                    </Button>
                  </div>
                )}
              </div>
            </DialogActions>
          </form>
        </Dialog>
        {/* MODAL CONCLUSÃO */}
        {/* <Dialog
                    open={this.state.modalGPS}
                    //TransitionComponent={Transition}
                    keepMounted
                    fullWidth
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogContent>
                        <div style={{textAlign: 'center'}}>
                            <h2>Permitir localização</h2>
                            <h5> 
                                Para continuar, por favor clique em permitir localização
                            </h5>
                            <div>
                                <div>
                                    Imagem de exemplo
                                </div>
                                <img src="/assets/imagem/geo-exemplo.png" alt="" style={{height: '50px', marginBottom: '2em'}} />
                            </div>
                            {this.props.isGeolocationEnabled == false ?
                                <div className={`alert alert-danger`} role="alert">
                                    Geolocalização desativada
                                </div>
                                :
                                null
                            }
                                <Button variant="contained" style={{backgroundColor: '#28a745', color: 'white'}} onClick={ () => this.setState({modalGPS: false})}>
                                    Ok, entendi
                                </Button>
                        </div>
                    </DialogContent>
                </Dialog> */}

        <ModalAlert
          open={this.state.confirm}
          handleClose={() => this.setState({ confirm: false })}
          action={() => this.saveData()}
          text="Ao clicar em continuar você estará declarando que está de acordo com os termos e condições do contrato"
          title="Atenção!"
          buttonClose="CANCELAR"
          buttonAccept="CONTINUAR"
        />
        <Dialog
          open={this.state.semSelfie}
          //TransitionComponent={Transition}
          keepMounted
          fullWidth
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <div style={{ textAlign: "center" }}>
              <h5>
                Selfie não identificada. Por favor, clique no botão "TIRAR
                SELFIE" para registrar sua selfie.
              </h5>
              <Button
                variant="contained"
                style={{ backgroundColor: "#28a745", color: "white" }}
                onClick={() => this.setState({ semSelfie: false })}
              >
                Ok, entendi
              </Button>
            </div>
          </DialogContent>
        </Dialog>
        <style>
          {`#root{ background: #dfdfdf;}
                    .box-container {
                        width: 95%;
                    }
                    .box-content {
                        padding-bottom: 48%;   
                    }
                    `}
        </style>
      </Container>
    );
  }
}

const mapStateToProps = ({ documentos }) => {
  return {
    documentos,
  };
};

export default geolocated({
  positionOptions: {
    enableHighAccuracy: false,
  },
  userDecisionTimeout: 5000,
})(
  connect(mapStateToProps, {
    salvarArquivo,
    limpaMsg,
    enviarEmailSig,
    deslogar,
  })(SelfieScreen)
);
